import { useEffect, useState } from "react";

const useClickListener = (toggleFunction: () => void) => {
  const [state, setState] = useState<boolean>(false);

  const keyEventListener = (event: KeyboardEvent) => {
    if (event.repeat || event.key != " ") return;
    toggleFunction();
  };

  const mouseEventListener = (event: MouseEvent) => {
    if (event.button != 0) return;
    toggleFunction();
  };

  const addListeners = () => {
    window.addEventListener("keypress", keyEventListener);
    window.addEventListener("mouseup", mouseEventListener);
  };

  const removeListeners = () => {
    window.removeEventListener("keypress", keyEventListener);
    window.removeEventListener("mouseup", mouseEventListener);
  };

  useEffect(() => {
    if (state) {
      addListeners();
    } else {
      removeListeners();
    }
    return () => {
      removeListeners();
    };
  }, [state]);

  return setState;
};

export default useClickListener;
